import React, { cloneElement } from 'react';

import { useCallbackWithAnalytics } from '@atlaskit/analytics-next';

const noop = () => {};
export function WebItemAnalyticsWrapper({
	children,
	analyticsData,
	innerRef,
	wrapChildren = false,
}: {
	children: React.ReactElement;
	analyticsData?: object;
	innerRef?: React.Ref<any>;
	wrapChildren?: boolean;
}): React.JSX.Element {
	const handler = children?.props?.onClick || noop;
	const handleClick = useCallbackWithAnalytics(handler, analyticsData!);
	if (wrapChildren) {
		const wrappedChild = cloneElement(children, {
			onClick: handleClick,
		});

		return <span ref={innerRef}>{wrappedChild}</span>;
	}
	return cloneElement(children, {
		onClick: handleClick,
		ref: innerRef,
	});
}
